module.exports = __webpack_public_path__ + "img/35Kennedy.1987a19f.png";